function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import { getRequestInfo } from '@applyboard/redux-bees';
import { getApplicationRequirementsAction } from "../../api/jsonapi";
import { buildObjectListCached } from "../../util/redux";
import { applicationIdSelector } from '@applyboard/ab-common';
import arrayEquals from "../../util/array_equals";
var defaultExtraParams = {
  include: ['application_additional_attachments', 'application_external_links', 'attachments', 'application_questions'].join(',')
};
export function createApplicationRequirementsSelector() {
  var extraParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultExtraParams;
  var documentsListBuilder = buildObjectListCached('application_document_requirements');
  var questionsListBuilder = buildObjectListCached('application_questions_requirements');
  var paymentsListBuilder = buildObjectListCached('application_payment_requirements');
  var receiptListBuilder = buildObjectListCached('application_receipt_requirements');
  var disclaimerListBuilder = buildObjectListCached('application_disclaimer_requirements');
  var hybridListBuilder = buildObjectListCached('application_hybrid_requirements');
  var cachedReturn = null;
  var cachedArgs = null;
  return function (state) {
    var applicationId = applicationIdSelector(state);
    var documentList = documentsListBuilder(state);
    var questionsList = questionsListBuilder(state);
    var paymentList = paymentsListBuilder(state);
    var receiptList = receiptListBuilder(state);
    var disclaimerList = disclaimerListBuilder(state);
    var hybridList = hybridListBuilder(state);
    if (!applicationId) return [];
    var args = [applicationId, documentList, questionsList, paymentList, receiptList, disclaimerList, hybridList];
    if (arrayEquals(args, cachedArgs)) return cachedReturn;
    cachedArgs = args;
    cachedReturn = [];
    var requestData = _objectSpread(_objectSpread({}, extraParams), {}, {
      // eslint-disable-next-line camelcase
      application_id: applicationId
    });
    var applicationContents = null;
    try {
      var requestInfo = getRequestInfo({
        bees: state.api
      }, getApplicationRequirementsAction, [requestData]);
      applicationContents = requestInfo.result;
    } catch (err) {
      // Do nothing
      return [];
    }
    if (!applicationContents) return [];
    var allRequirements = [].concat(_toConsumableArray(documentList), _toConsumableArray(questionsList), _toConsumableArray(paymentList), _toConsumableArray(receiptList), _toConsumableArray(disclaimerList), _toConsumableArray(hybridList));
    var applicationRequirementsIds = allRequirements.map(function (e) {
      return typeof e.id === 'number' ? e.id : parseInt(e.id, 10);
    });
    cachedReturn = allRequirements.filter(function (e) {
      return applicationRequirementsIds.indexOf(e.id) >= 0;
    });
    return cachedReturn;
  };
}